export default __webpack_public_path__ + "static/combocaster-4aab6b85311331deeaea9a254615e821.png";